export enum MicrophoneErrorEnum {
  PERMISSION_DENIED = "microphoneFeature.errors.permissionDenied",
}

export type MicrophoneError = MicrophoneErrorEnum;
